module.exports = __webpack_public_path__ + "img/20.721ad1f1.png";